import { BordLateralModal } from 'bord-design-system';

import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import useLockScroll from 'hooks/useLockScroll';
import CustomerChatPanel from 'components/CustomerChatPanel/CustomerChatPanel';
import {
  CUSTOMER_CHAT_BACKGROUND_SCROLL_LOCK_SELECTORS,
  CUSTOMER_CHAT_DESCRIPTION_BY_ENTITY
} from 'constants/constants';
import { TCustomerChatEntityType } from 'types/customerChat.types';

import './CustomerChatLateralModal.scss';

interface ICustomerChatLateralModal {
  open: boolean;
  onClose: () => void;
  mode: TCustomerChatEntityType;
  entityId: number;
  isEntityCancelled?: boolean;
  onAfterSend?: () => void | Promise<void>;
}

const CustomerChatLateralModal = ({
  open,
  onClose,
  mode,
  entityId,
  isEntityCancelled = false,
  onAfterSend
}: ICustomerChatLateralModal) => {
  useLockScroll(open, CUSTOMER_CHAT_BACKGROUND_SCROLL_LOCK_SELECTORS);

  const headerLeadingIcon = (
    <div className="customerChatLateralModalHeaderLeading">
      <BordOneToneIcon variant="messageSquare" standardSize={24} stroke="white" />
    </div>
  );

  return (
    <BordLateralModal
      open={open}
      onClose={onClose}
      closesOnOverlayClick
      panelMaxWidth="48rem"
      className="customerChatLateralModal"
      panelClassName="customerChatLateralModalPanel"
      bordLateralModalHeaderProps={{
        title: 'Chat con el cliente',
        subtitle: CUSTOMER_CHAT_DESCRIPTION_BY_ENTITY[mode],
        leading: headerLeadingIcon,
        onClose,
        className: 'customerChatLateralModalHeader',
        titleClassName: 'customerChatLateralModalHeaderTitle',
        subtitleClassName: 'customerChatLateralModalHeaderSubtitle'
      }}
      bordLateralModalContent={
        <div className="customerChatLateralModalContent">
          <CustomerChatPanel
            mode={mode}
            entityId={entityId}
            onAfterSend={onAfterSend}
            isEntityCancelled={isEntityCancelled}
          />
        </div>
      }
    />
  );
};

export default CustomerChatLateralModal;
